import { VsfContext } from '~/composables/context';
import { Logger } from '~/helpers/logger';
import { Cart } from '~/modules/GraphQL/types';

import { confirmedMutationCart } from '../cartMutationResult';

export const applyCouponCommand = {
  execute: async (context: VsfContext, { currentCart, couponCode, customQuery, customHeaders = {} }) => {
    Logger.debug('[Magento]: Apply coupon on cart', {
      couponCode,
      currentCart,
    });

    const response = await context.$magento.api.applyCouponToCart({
      cart_id: currentCart.id,
      coupon_code: couponCode,
    }, customQuery, customHeaders);
    const { data, errors } = response || {};

    Logger.debug('[Result]:', { data, errors });

    return {
      updatedCart: errors?.length && data?.applyCouponToCart == null
        ? undefined : confirmedMutationCart({ data, errors }, 'applyCouponToCart', currentCart.id) as Cart,
      updatedCoupon: { code: couponCode },
      errors,
    };
  },
};
